import React, { useMemo } from 'react'
import VerticalGroup from '../../../atoms/verticalgroup/VerticalGroup'
import TableWithSections from '../tables/TableWithSections'
import { percentage } from '../utils/formatters'
import getTeamIdsAsFields from '../utils/getTeamIdsAsFields'
import getTeamName from '../utils/getTeamName'
import pluckResultsByType from '../utils/pluckResultsByType'

interface Props {
  configuration: ModelAPI.ConfigurationResponse
  data: ModelAPI.DecisionsResponse['dividendReinvestmentPlan']
  teams: API.GameConnection[]
}

const DividendReinvestmentPlan: React.FC<Props> = ({ configuration, data, teams }) => {
  const { numberOfTeams, numberOfCpuTeams } = configuration
  const totalNumberOfTeams = numberOfTeams + numberOfCpuTeams
  const fields = useMemo(() => getTeamIdsAsFields(totalNumberOfTeams), [totalNumberOfTeams])

  return (<>
    <VerticalGroup className='mt-2' spaceBetweenElements={2} wide>
      <TableWithSections
        header='Dividend Reinvestment Plan Allocation'
        data={[{
          fields,
          values: pluckResultsByType(data, 'dividendReinvestmentPlanAllocation')
        }]}
        fieldFormatter={(field: string) => getTeamName(parseInt(field), numberOfTeams, teams)}
        formatter={(value: any) => value === 0 ? '-' : percentage(value)}
      />
    </VerticalGroup>
  </>)
}

export default DividendReinvestmentPlan